import { useEffect, useState } from 'react';
import enviroment from '../../../enviroment';
import moment, { whatIsMyTimeZone } from "../../../helpers/moment-helpers";
import { useSelector } from 'react-redux';

const TimeZoneView = () => {
    const [time, setTime] = useState(null);
    const [timeLocal, setTimeLocal] = useState(null);
    //const [isVisible, setIsVisible] = useState(false);
    const me = useSelector(state => state.me);
    const isVisible = !!me?.settings?.showTimeZone

    const handleCalculateTime = () => {
        const interval = setInterval(() => {
            const timeAux = moment();
            setTime(timeAux);
            const timeLocalAux = moment.tz(whatIsMyTimeZone());

            /* if(timeAux.format('h:mm a') !== timeLocalAux.format('h:mm a')) {
                setIsVisible(true);
            } */
            setTimeLocal(timeLocalAux);
        }, 1000);

        return () => clearInterval(interval);
    };

    /* const showConfig = () => {
        //let showTimeConfig = localStorage.getItem('showTimeConfig');
        //showTimeConfig = showTimeConfig === 'true';
        //setIsVisible(me?.settings?.showTimeZone);
    }; */

    useEffect(() => {
        handleCalculateTime();
        //showConfig();

        // eslint-disable-next-line
    }, []);

    return (
        <div style={{ display: isVisible ? 'block' : 'none' }}>
            <div>
                {'Local'} time: {timeLocal?.format('h:mm:ss a') || 'Calculating...'}
            </div>
            <div>
                {enviroment.timeZone} time: {time?.format('h:mm:ss a') || 'Calculating...'}
            </div>
        </div>
    );
};

export default TimeZoneView;
